// extracted by mini-css-extract-plugin
export var main = "redirection-info-module--main--LcLG1";